// src/HeroPage/CategoriesDisplay.tsx
import React from "react";

import ProductDisplay from "./productDisplay";

const CategoriesDisplay: React.FC = () => {
  return (
    <>
      {/* Next section */}
      <ProductDisplay />
    </>
  );
};

export default CategoriesDisplay;
